module.exports = __webpack_public_path__ + "static/img/dafanweilitishi.b412285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dafanweilitishi.png
// module id = YI8+
// module chunks = 3